import { FaStar, FaRegStar } from "react-icons/fa";

export default function StarRating({ rating = 5 }) {
  return (
    <span className="stars" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) =>
        n <= rating ? <FaStar key={n} /> : <FaRegStar key={n} />
      )}
    </span>
  );
}
